document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.timeline');
  if (!section) return;

  const container = section.querySelector('.timeline__items');
  const sticky    = section.querySelector('.timeline__sticky');
  const cards     = Array.from(section.querySelectorAll('.timeline__item'));
  const images    = Array.from(section.querySelectorAll('.timeline-image'));
  if (!cards.length) return;

  section.style.setProperty('--items', cards.length);

  // --i pairs each image with its card, so the static layout can show them together
  cards.forEach((card, i) => card.style.setProperty('--i', i));
  images.forEach((img, i) => img.style.setProperty('--i', i));

  // GSAP comes from a CDN. If it's blocked or fails, show the static layout instead of blank cards
  if (!window.gsap || !window.ScrollTrigger) {
    section.classList.add('is-static');
    return;
  }
  gsap.registerPlugin(ScrollTrigger);

  // Measurements, re-read whenever ScrollTrigger refreshes (resize, breakpoint changes)
  const cardWidth = () => cards[0].offsetWidth;
  const step      = () => cardWidth() + (parseFloat(getComputedStyle(container).columnGap) || 0);
  const distance  = () => step() * (cards.length - 1);
  const startX    = () => (document.documentElement.clientWidth - cardWidth()) / 2;

  const mm = gsap.matchMedia();

  // Scroll-jacked horizontal timeline
  mm.add('(prefers-reduced-motion: no-preference)', () => {
    let cardStep = step();
    let halfView = document.documentElement.clientWidth / 2;
    let active   = -1;

    function setActive(index) {
      if (index === active) return;
      active = index;
      images.forEach((img, i) => {
        const isActive = i === index;
        img.classList.toggle('active', isActive);
        img.style.transform = isActive
          ? `translateX(-50%) rotate(${i % 2 ? 4 : -4}deg) scale(1.02)`
          : 'translateX(-50%) rotate(0deg)';
      });
    }

    // Fade each card by its distance from the centre of the screen. Worked out from the
    // scroll progress rather than measuring every card on every frame.
    function update(progress) {
      const position = progress * (cards.length - 1);
      cards.forEach((card, i) => {
        const dist = Math.abs(i - position) * cardStep;
        card.style.opacity = (1 - Math.min(dist / halfView, 1)).toFixed(2);
      });
      setActive(Math.round(position));
    }

    const tween = gsap.fromTo(container, { x: startX }, {
      x: () => startX() - distance(),
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start:   'top -40%',
        end:     () => `+=${distance()}`,
        scrub:   true,
        pin:     sticky,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        toggleClass: { targets: section, className: 'is-pinned' },
        onRefresh(self) {
          cardStep = step();
          halfView = document.documentElement.clientWidth / 2;
          update(self.progress);
        },
        onUpdate: self => update(self.progress)
      }
    });

    // Cards off to the side are see-through, but their links can still be tabbed to.
    // Scroll the page so the card holding the focused link slides into the middle.
    function onFocusIn(e) {
      const index = cards.findIndex(card => card.contains(e.target));
      const st = tween.scrollTrigger;
      if (index < 0 || !st) return;
      window.scrollTo(0, st.start + (st.end - st.start) * (index / (cards.length - 1)));
    }
    section.addEventListener('focusin', onFocusIn);

    update(0);

    return () => {
      section.removeEventListener('focusin', onFocusIn);
      section.classList.remove('is-pinned');
      cards.forEach(card => (card.style.opacity = ''));
      images.forEach(img => {
        img.classList.remove('active');
        img.style.transform = '';
      });
    };
  });

  // Visitors who ask for less motion get the plain vertical timeline
  mm.add('(prefers-reduced-motion: reduce)', () => {
    section.classList.add('is-static');
    return () => section.classList.remove('is-static');
  });
});
